import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { lazy, Suspense } from 'react';
import useDeferredFileUsage from 'src/hooks/useDeferredFileUsage';

const EditorWithMediaManager = lazy(() => import('./EditorWithMediaManager'));

interface Props {
  value?: string;
  onChange(v: string): void;
  height?: number;
  contentType?: string;
  contentId?: string;
  fieldName?: string;
  onFileSelected?: (fileId: string) => void;
}

export default function Editor({
  value = '',
  onChange,
  height = 300,
  contentType,
  contentId,
  fieldName,
  onFileSelected,
}: Props) {
  const deferredFileUsage = useDeferredFileUsage({
    contentType: contentType || 'pageContent',
    contentId: contentId || 'unknown',
    fieldName: fieldName || 'content',
  });

  const handleFileSelected = (fileId: string) => {
    if (contentType && contentId && fieldName) {
      deferredFileUsage.addPendingFile(fileId);
    } else {
      onFileSelected?.(fileId);
    }
  };

  return (
    <Box sx={{ minWidth: 0, maxWidth: '100%' }}>
      <Suspense
        fallback={
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress size={28} />
          </Box>
        }
      >
        <EditorWithMediaManager
          value={value}
          onChange={onChange}
          height={height}
          onFileSelected={handleFileSelected}
        />
      </Suspense>
    </Box>
  );
}

export function useEditorFileHandlers(contentType: string, contentId: string, fieldName: string) {
  const { markPendingFilesAsUsed, clearPendingFiles } = useDeferredFileUsage({
    contentType,
    contentId,
    fieldName,
  });

  return {
    markPendingFilesAsUsed,
    clearPendingFiles,
  };
}

;
